import React, { useState } from 'react';
import { sendMessage, createMpAvatar } from './mpDisplayFunc';

import CircularProgress from '@material-ui/core/CircularProgress';

import MpIFrame from './MpIFrame';

export default function MpDisplay(props) {
    const {settings, apiHost, appMode} = props;
    const [avatarState, setAvatarState] = useState('EMPTY');
    const [container, setContainer] = useState(document.getElementById('mp-iframe'));
    const [containerState, setContainerState] = useState({ping:false, referred:false});
    const [doOnce, setDoOnce] = useState(false);    

    const [IFrame,] = useState(MpIFrame({setContainer}));    

    // Function to handle messages from MP iFrame
    const handleContainerMessage = message => {                 
        // Handle pings when iframe first created
        if (message.data === 'ping' && containerState.ping === false)         
            setContainerState({...containerState, ping:true});                           
        // Handle when avatar image is completely loaded
        else if (message.data === 'avatar_loaded')        
            setAvatarState('CREATED');    
    };

    // create a listener for iFrame messages, do this once
    if(!doOnce)
    {
        window.addEventListener('message', message => handleContainerMessage(message));
        setDoOnce(true);
    }                       

    const CircularProgressStyle = {marginTop:'300px'}
    const displayStyle = {
        padding:'20px',
        display: (appMode === 'AVATAR' && 'block') || 'none',
        textAlign:'center',
        width:'650px',
        height:'650px',
    }
    
    // Only interact with the container when it has confirmed creation    
    if(containerState.ping && container && appMode === 'AVATAR')
    {        
        if(avatarState === 'EMPTY')
        {            
            // Create the avatar bin
            setAvatarState('LOADING');
            const response = createMpAvatar(settings.faceImageBase64, apiHost);                       
            response.then(avatarBinBase64 => {                
                // Tell iframe to create the avatar                
                const message = {
                    type:'CREATE_AVATAR',
                    base64Avatar:avatarBinBase64,
                };
                sendMessage(container, message);
                setAvatarState('LOADING');
            });
        }
        else if(avatarState === 'CREATED')
        {
            const message = {
                type:'CHANGE_MAKEUP',
                ...settings.makeup,
            };
            sendMessage(container, message);
        }        
    }    

    
    return (
        <div style={displayStyle}>     
            {avatarState !== 'CREATED' && <CircularProgress size={100} style={CircularProgressStyle}/>}       
            <div style={(avatarState !== 'CREATED' && {display:'none'}) || {}}>
                {IFrame}    
            </div>            
        </div>
    )
}